import React, { Component } from "react";
import PropTypes from "prop-types";

class ClickOutside extends Component {
  setRef = ref => {
    this.container = ref;
  };

  componentDidMount() {
    const { isActive } = this.props;
    if (isActive) {
      this.addListener();
    }
  }

  componentDidUpdate(prevProps) {
    const { isActive } = this.props;
    if (prevProps.isActive !== isActive) {
      if (isActive) {
        this.addListener();
      } else {
        this.removeListener();
      }
    }
  }

  componentWillUnmount() {
    const { isActive } = this.props;
    if (isActive) {
      this.removeListener();
    }
  }

  addListener() {
    document.addEventListener("click", this.handle, true);
  }

  removeListener() {
    document.removeEventListener("click", this.handle, true);
  }

  handle = e => {
    const { onClickOutside } = this.props;
    const el = this.container;
    if (!el.contains(e.target)) onClickOutside(e);
  };

  render() {
    const { setRef, props } = this;
    const { children } = props;
    return children({ setRef });
  }
}

ClickOutside.defaultProps = {
  isActive: true
};

ClickOutside.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onClickOutside: PropTypes.func.isRequired
};

export default ClickOutside;



// WEBPACK FOOTER //
// ./casper/sass/components/click-outside/click-outside.js